'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('./m_typeahead_helper_es6'),
    matchesFuzzy = _require.matchesFuzzy,
    highlightWords = _require.highlightWords;

var _require2 = require('./m_normalizeQuery.coffee'),
    normalizeQuery = _require2.normalizeQuery;

var clearingPartial = require('./templates/partial_clearing.html.mustache');
var newBadgePartial = require('./templates/partial_new_badge.html.mustache');
var currentLocationPartial = require('./templates/partial_current_location.html.mustache');
var recentLocationPartial = require('./templates/partial_recent_location.html.mustache');
var autocompletePartial = require('./templates/partial_autocomplete.html.mustache');
var recentSearchPartial = require('./templates/partial_recent_search.html.mustache');
var myPlacesPartial = require('./templates/partial_my_places.html.mustache');
var searchCategoriesPartial = require('./templates/partial_search_categories.html.mustache');

var locationTemplate = require('./templates/template_location.html.mustache');
var searchTemplate = require('./templates/template_search.html.mustache');

var _require3 = require('../../general/m_userSessionAddReferrer.coffee'),
    getSigninUrl = _require3.getSigninUrl;

var _require4 = require('../../../../../src/helpers/camelCase.coffee'),
    toCamelCase = _require4.toCamelCase;

// Build the html of the autocomplete


var TypeAHeadBuilder = function () {
  function TypeAHeadBuilder() {
    _classCallCheck(this, TypeAHeadBuilder);

    var translations = Groupon.LS.translations;
    this.t = {
      currentlocation: translations.search && translations.search.currentlocation,
      remove: translations.ax.remove,
      clearall: translations.search.clearall,
      recentSearchs: translations.search.recentdeals,
      recentLocations: translations.search.recentlocations,
      categories: translations.categories || {},
      newBadge: translations.general.newbadge,
      signIn: 'Sign in', // TODO: translation
      myPlaces: translations.search.myPlaces || 'My Places', // TODO: translation
      addMyPlace: translations.search.addMyPlace || 'Add Address', // TODO: translation
      seeMore: 'See more',
      myPlaceTypes: { // TODO: translation
        home: translations.search.myPlaceTypeHome || 'Home',
        work: translations.search.myPlaceTypeWork || 'Work',
        play: translations.search.myPlaceTypeFavorite || 'Favorite'
      }
    };
  }

  // Injects html tags to separate the neighborhood and the city


  _createClass(TypeAHeadBuilder, [{
    key: 'deEmphasis',
    value: function deEmphasis() {
      var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      var res = label.split(/,(.+)?/);
      var parts = label.split(',');
      if (parts.length < len) {
        return label;
      }
      var tag = '<em>';
      if (label.indexOf('<strong>') > -1) {
        // strong tags present either in <neightborhood> or <city , state>"
        if (!(res[0].indexOf('</strong>') > -1 || res[1].indexOf('<strong>') > -1)) {
          // strong tags present in both parts of the label
          tag = '</strong><em><strong>';
        }
      }
      res.splice(1, 0, tag);
      res.splice(3, 0, '</em>');
      return res.join('');
    }

    // Format tag

  }, {
    key: 'prepareBloodhoundTag',
    value: function prepareBloodhoundTag() {
      var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return tag.toLowerCase().replace(/[^\w\d]+/g, '_');
    }

    // get all the default data

  }, {
    key: 'getDefaultData',
    value: function getDefaultData(collections, query) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var firstWidget = collections[0] && (collections[0].widget || '');

      var bh = void 0;
      if (firstWidget === 'autocomplete') {
        bh = {
          type: 'bhc',
          val: 'UserTyped:' + query
        };
      } else {
        bh = {
          type: 'bhw',
          val: firstWidget.replace(/^(.)/g, function ($1) {
            return $1.toUpperCase();
          })
        };
      }

      return {
        t: this.t,
        isDesktop: config.isDesktop,
        query: query,
        bh: bh
      };
    }

    // build the autocomplete view for deals search

  }, {
    key: 'buildSearchView',
    value: function buildSearchView(collections, query) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var data = Object.assign(this.getDefaultData(collections, query, config), {
        items: this.buildSearchItems(collections, query)
      });

      var partials = {
        autocompletePartial: autocompletePartial,
        recentSearchPartial: recentSearchPartial,
        searchCategoriesPartial: searchCategoriesPartial,
        clearingPartial: clearingPartial,
        newBadgePartial: newBadgePartial
      };

      return searchTemplate.render(data, partials);
    }
  }, {
    key: 'buildSearchItems',
    value: function buildSearchItems(collections, query) {
      var _this = this;

      var items = collections.reduce(function (results, _ref) {
        var collection = _ref.collection,
            widget = _ref.widget;

        switch (widget) {
          case 'autocomplete':
            return results.concat(_this.buildAutocomplete(collection, query));
          case 'recentSearches':
            return results.concat(_this.buildRecentSearches(collection, query));
          case 'searchCategories':
            return results.concat(_this.buildSearchCategories(collection, query));
          default:
        }
        return results;
      }, []);
      return items;
    }
  }, {
    key: 'createBloodhoundTag',
    value: function createBloodhoundTag() {
      var categoryType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var type = categoryType.split('|').map(function (part) {
        return toCamelCase(part);
      }).join('');
      return 'TouchSearchCategory' + type;
    }
  }, {
    key: 'buildSearchCategory',
    value: function buildSearchCategory(categoryType, categoryItems) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var name = this.t.categories[categoryType]; // get name from translation
      var baseBHW = this.createBloodhoundTag(categoryType);
      var heading = null;

      if (name) {
        heading = {
          isSearchCategoriesHeader: true,
          name: name
        };
      }

      var baseUrl = categoryItems[0] ? categoryItems[0].baseUrl : null;
      if (baseUrl) {
        categoryItems.shift(); // remove the baseUrl item
      }

      var items = categoryItems.map(function (item) {
        /*
        # item can be either of type "Array" or "Object"
        # API facets are normally mapped as arrays
        # while config or constructed entries (all deals) ar
        # mapped as object.
        */
        var dataItem = {
          isSearchCategoryItem: true,
          item: item
        };

        if (Array.isArray(item)) {
          var _item = _slicedToArray(item, 4),
              id = _item[0],
              friendlyName = _item[1],
              count = _item[2],
              subcategories = _item[3];

          Object.assign(dataItem, { id: id, friendlyName: friendlyName, count: count, subcategories: subcategories, url: baseUrl + id });
        } else {
          var _id = item.i,
              _friendlyName = item.n,
              _count = item.c,
              _subcategories = item.s,
              url = item.u,
              newBadge = item.newBadge;

          Object.assign(dataItem, { id: _id, friendlyName: _friendlyName, count: _count, subcategories: _subcategories, newBadge: newBadge, url: url });
        }

        dataItem.bhw = '' + baseBHW + toCamelCase(dataItem.id || 'AllDeal');

        return dataItem;
      });

      return {
        isSearchCategory: true,
        type: categoryType,
        heading: heading,
        menuID: categoryType.split('|').pop(),
        items: items,
        level: level
      };
    }

    // search categories for mobile search

  }, {
    key: 'buildSearchCategories',
    value: function buildSearchCategories(collection) {
      var _this2 = this;

      if (!collection || !collection[0]) {
        return [];
      }

      var categoriesMap = collection[0];

      return Object.keys(categoriesMap).reduce(function (result, categoryType) {
        var categoryItems = categoriesMap[categoryType] || [];
        if (categoryItems.length) {
          // check category items
          result.push(_this2.buildSearchCategory(categoryType, categoryItems.slice(0)));
        }
        return result;
      }, []);
    }
  }, {
    key: 'buildRecentSearches',
    value: function buildRecentSearches(collection) {
      var _this3 = this;

      if (!collection || !collection.length) {
        return [];
      }

      var items = collection.map(function (item, n) {
        return {
          isRecentSearchItem: true,
          item: item,
          n: n,
          bhc: _this3.prepareBloodhoundTag(item)
        };
      });
      items.unshift({ isRecentSearchHeader: true });

      return items;
    }

    // build the autocomplete view for location search

  }, {
    key: 'buildLocationView',
    value: function buildLocationView(collections, query) {
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var data = Object.assign(this.getDefaultData(collections, query, config), this.buildLocationItems(collections, query, config));

      var partials = {
        currentLocationPartial: currentLocationPartial,
        recentLocationPartial: recentLocationPartial,
        clearingPartial: clearingPartial,
        autocompletePartial: autocompletePartial,
        myPlacesPartial: myPlacesPartial
      };

      return locationTemplate.render(data, partials);
    }
  }, {
    key: 'buildLocationItems',
    value: function buildLocationItems(collections, query, config) {
      var _this4 = this;

      var isGeoLocation = false;
      var items = collections.reduce(function (results, _ref2) {
        var collection = _ref2.collection,
            widget = _ref2.widget;

        switch (widget) {
          case 'geolocation':
            isGeoLocation = true;
            break;
          case 'recentLocations':
            return results.concat(_this4.buildRecentLocations(collection));
          case 'autocomplete':
            return results.concat(_this4.buildAutocomplete(collection, query));
          case 'myPlaces':
            return results.concat(_this4.buildMyPlaces(collection, query, config));
          default:
        }
        return results;
      }, []);
      return {
        items: items,
        isGeoLocation: isGeoLocation
      };
    }

    // recent location list

  }, {
    key: 'buildRecentLocations',
    value: function buildRecentLocations(collection) {
      var _this5 = this;

      if (!collection || !collection.length) {
        return [];
      }

      var items = collection.map(function (item, n) {
        var address = item.address;
        // set value as full address

        var value = address;
        // display address without zipcode and country
        var label = _this5.deEmphasis(address, 3);
        return Object.assign({}, item, {
          isRecentLocationItem: true,
          n: n,
          value: value,
          label: label,
          bhc: _this5.prepareBloodhoundTag(address)
        });
      });
      items.unshift({ isRecentLocationHeader: true });

      return items;
    }
  }, {
    key: 'buildAutocomplete',
    value: function buildAutocomplete(collection, query) {
      var _this6 = this;

      if (!collection || !collection.length) {
        return [];
      }

      return collection.map(function (item, n) {
        var value = item.value,
            label = item.label,
            address = item.address;


        if (item.lat && item.neighborhood) {
          label = _this6.deEmphasis(label);
        }

        if (item.locationId && address) {
          value = address;
          address = highlightWords(address, matchesFuzzy(query, address, true));
          label = _this6.deEmphasis(address);
        }

        return Object.assign({}, item, {
          isAutocomplete: true,
          n: n,
          value: value,
          address: address,
          label: label,
          highlight: normalizeQuery(value) === query
        });
      });
    }
  }, {
    key: 'buildMyPlaces',
    value: function buildMyPlaces(collection, query, config) {
      var _this7 = this;

      var isAddMyPlace = true;
      var isMorePlace = false;
      var displayedItems = collection;
      if (config.places.needToBeCollapsed()) {
        displayedItems = collection.slice(0, 3);
        isAddMyPlace = false;
        isMorePlace = true;
      }

      var items = displayedItems.map(function (item, n) {
        var address = item.address,
            type = item.type;

        return Object.assign(item, {
          isMyPlacesItem: true,
          n: n,
          bhc: _this7.prepareBloodhoundTag(address),
          name: _this7.t.myPlaceTypes[type] || _this7.t.myPlaceTypes.home
        });
      });

      var signInUrl = !config.isLoggedIn ? getSigninUrl() : null;
      items.unshift({ isMyPlacesHeader: true, signInUrl: signInUrl });
      if (isAddMyPlace) {
        items.push({ isAddMyPlace: isAddMyPlace });
      }
      if (isMorePlace) {
        items.push({ isMorePlace: isMorePlace });
      }

      return items;
    }
  }]);

  return TypeAHeadBuilder;
}();

module.exports = new TypeAHeadBuilder();